import { Action } from "./Action.js";
/**
 * @class OpenPrintDialog
 * @extends Action
 * @classdesc Действие Открыть окно печати
 * Вызвать окно печати (работает как Ctrl+P, на текущем открытом окне)
 * */
export class OpenPrintDialog extends Action {
    execute() {
        if (!this.hasStyles) {
            this.stylePrintPage();
        }

        if (window.ipc && window.clientPrinter) {
            window.ipc.get().send("server", "print");
            return;
        }

        window.print();
    }

    stylePrintPage() {
        const stylesheet = document.createElement("style");
        const { offsetWidth } = document.body.querySelector("ms-window");
        const heightPx = 1123; // 794px/1123px при 96 dpi для A4 при портретной ориентации
        const scale = heightPx * this.getScaleCoef() / offsetWidth; // без margin по бокам

        stylesheet.innerText = `
            @media print {
                @page {
                    margin: 0;
                    size: landscape;
                }

                body > ms-window {
                    /* Этот параметр будет отрисовывать цвета и отображать картинки при печати */
                    -webkit-print-color-adjust: exact; /* для хрома */
                    color-adjust: exact; /* для firefox */

                    transform: scale(${scale}) !important;
                }
    
                .tooltip {
                    display: none;
                }
            }
        `;
        document.head.appendChild(stylesheet);

        this.hasStyles = true;
    }

    getScaleCoef() {
        if (!window.ipc) {
            return 1;
        }
        // Метод "getElectronVersion" был добавлен в 31 версии электрона. В предыдущей версии - в 22ой, его не было, поэтому по умолчанию 22.
        const electronVersion = window.ipc.get().sendSync("server", "getElectronVersion") ?? 22;
        // В версии electron 22 нужно умножать на 1.5, вероятно этот коэффициент зашит где-то в электроне.
        // Начиная с 23 версии electron, умножать на этот коэффициент уже не нужно.
        return parseInt(electronVersion) > 22 ? 1 : 1.5;
    }
}
